import { Ticket } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-svj-card border-t border-svj-border mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-svj-orange via-svj-pink to-svj-purple">
              <Ticket className="h-5 w-5 text-white" />
            </span>
            <span className="text-white font-extrabold tracking-tight text-lg">
              StudioVoorJou <span className="text-svj-cyan">Tickets</span>
            </span>
          </div>
          <p className="mt-4 text-sm text-slate-400 max-w-sm leading-relaxed">
            Tickets voor lokale events, festivals en buurtactiviteiten — samengesteld door StudioVoorJou.
          </p>
        </div>
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-slate-400">Platform</div>
          <ul className="mt-4 space-y-2 text-sm text-slate-300">
            <li><a href="/events" className="hover:text-white">Events</a></li>
            <li><a href="/voorwaarden" data-testid="footer-terms-link" className="hover:text-white">Algemene voorwaarden</a></li>
            <li><a href="/privacybeleid" data-testid="footer-privacy-link" className="hover:text-white">Privacybeleid</a></li>
            <li><a href="/admin/login" className="hover:text-white">Beheer</a></li>
          </ul>
        </div>
        <div>
          <div className="text-xs font-semibold uppercase tracking-widest text-slate-400">Contact</div>
          <ul className="mt-4 space-y-2 text-sm text-slate-300">
            <li><a href="https://studiovoorjou.nl" target="_blank" rel="noopener noreferrer" className="hover:text-white">StudioVoorJou</a></li>
            <li className="text-slate-400">Nederland</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-svj-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-500 flex justify-between">
          <span>© {new Date().getFullYear()} StudioVoorJou</span>
          <span>Veilig betalen</span>
        </div>
      </div>
    </footer>
  );
}
